howspace.animate = async (elem, propsOrFn, duration, completeFn) => {
    await lib('velocity-animate', 'velocity.min.js');

    if (!howspace.animate.isEnabled()) {
        // Animations are disabled, set animation duration to zero milliseconds.
        duration = 0;
    }

    if (elem instanceof jQuery) {
        // Given element is a jQuery object, turn it into a native array.
        elem = elem.toArray();
    }

    if (!Array.isArray(elem)) {
        // Single native DOM element, wrap it into an array.
        elem = [elem];
    }

    elem.forEach(loopElem => {
        if (loopElem instanceof jQuery) {
            // An array of jQuery elements given. Turn the looped element into native DOM element.
            loopElem = loopElem[0];
        }

        // Try to figure out a proper display property to be used in the animation.
        let display = null;
        if (loopElem.classList.contains('grid')) {
            display = 'grid';
        } else if (loopElem.classList.contains('inline-grid')) {
            display = 'inline-grid';
        } else if (loopElem.classList.contains('flex')) {
            display = 'flex';
        } else if (loopElem.classList.contains('inline-flex')) {
            display = 'inline-flex';
        } else {
            display = 'block';
        }

        // Stop the previous animation (if any).
        $.Velocity(loopElem, 'stop');

        if (propsOrFn === 'slideDown' && loopElem.classList.contains('d-none')) {
            // Remove the d-none class before starting slideDown animation.
            loopElem.classList.remove('d-none');
        }

        // Start the new animation.
        $.Velocity(loopElem, propsOrFn, {
            duration: duration,
            display: display
        }).then(() => {
            /**
             * The "complete" event callback will not execute if the animation is stopped using the "stop" function.
             * http://velocityjs.org/#stop
             *
             * Thus, use the promise as we want to always execute this once the animation stops regardless did the
             * animation finish on its own or did something stop it with the "stop" function.
             * http://velocityjs.org/#promises
             */
            loopElem.style.display = '';
            if (propsOrFn === 'slideUp') {
                loopElem.classList.add('d-none');
            }
            if (typeof completeFn === 'function') {
                completeFn(loopElem);
            }
            howspace.dispatchEvent(loopElem, howspace.animate.ANIMATION_COMPLETED);
        });
    });
};

howspace.animate.ANIMATION_COMPLETED = 'howspace-animation-completed';
howspace.animate.disabledWithCssParam = howspace.getCssVariable(document.documentElement, '--howspace-animations-enabled') !== 'true';
howspace.animate.disabledWithSetter = false;

howspace.animate.enable = () => {
    howspace.animate.disabledWithSetter = false;
};

howspace.animate.disable = () => {
    howspace.animate.disabledWithSetter = true;
};

howspace.animate.isEnabled = () => {
    return !howspace.animate.disabledWithSetter && !howspace.animate.disabledWithCssParam;
}
